<template>
  <el-dialog
    :title="editar ? 'Editar Colaborador' : 'Cadastrar Colaborador'"
    :visible.sync="abrirDialog.aberto"
    @close="fecharDialog"
    class="dialog">
    <span>
      <el-form :model="colaborador" status-icon :ref="colaborador" :rules="regras" label-width="130px">
        <el-form-item label="Nome" prop="nome">
          <el-input v-model="colaborador.nome" :disabled="editar"></el-input>
        </el-form-item>

        <el-form-item label="Sobrenome" prop="sobrenome">
          <el-input v-model="colaborador.sobrenome" :disabled="editar"></el-input>
        </el-form-item>

        <el-form-item label="Adminstrador?" prop="isAdmin">
          <el-switch v-model="colaborador.isAdmin"></el-switch>
        </el-form-item>

        <el-form-item label="E-mail" prop="email">
          <el-input v-model="colaborador.email" :disabled="editar"></el-input>
        </el-form-item>

        <el-form-item v-if="!editar" label="Senha" prop="senha">
          <el-input v-model="colaborador.senha" type="password"></el-input>
        </el-form-item>

        <el-form-item v-if="!editar" label="Confirmar Senha" prop="confirmarSenha">
          <el-input v-model="colaborador.confirmarSenha" type="password"></el-input>
        </el-form-item>

        <el-form-item label="Horas Semanais" prop="horasSemana">
          <el-input v-model.number="colaborador.horasSemana">
            <template slot="append">horas</template>
          </el-input>
        </el-form-item>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button class="botao-cancelar" @click="fecharDialog">Cancelar</el-button>
      <el-button v-if="editar" class="botao" @click="editarColaborador()" :loading="carregando">Editar</el-button>
      <el-button v-else class="botao" @click="cadatrarColaborador()" :loading="carregando">Cadastrar</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    abrirDialog: {
      type: Object,
      required: true
    },
    colaboradorSelecionado: {
      type: Object,
      required: false
    },
    editar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validaSenha = (rule, value, callback) => {
      if (!value) callback(new Error('Por favor, digite a senha'));
      else if (value.length < 6) callback(new Error('A senha deve ter no mínimo 6 caracteres'));
      else callback();
    };
    const validaConfirmarSenha = (rule, value, callback) => {
      if (!value) callback(new Error('Por favor, digite a senha novamente'));
      else if (value !== this.colaborador.senha) callback(new Error('A senha é diferente!'));
      else callback();
    };
    return {
      carregando: false,
      colaborador: {
        isAdmin: false
      },
      regras: {
        nome: [
          { required: true, message: 'O nome é obrigatório', trigger: 'blur' }
        ],
        sobrenome: [
          { required: true, message: 'O sobrenome é obrigatório', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'O e-mail é obrigatório', trigger: 'blur' },
          { type: 'email', message: 'Por favor, entre com um e-mail válido', trigger: ['blur', 'change'] }
        ],
        senha: [
          !this.editar
            ? { validator: validaSenha, trigger: 'blur' } : {}
        ],
        confirmarSenha: [
          !this.editar
            ? { validator: validaConfirmarSenha, trigger: 'blur' } : {}
        ],
        horasSemana: [
          { required: true, message: 'A quantidade de horas é obrigatória', trigger: 'blur' },
          { type: 'number', message: 'As horas devem ser números' }
        ]
      }
    };
  },
  created() {
    if (this.editar) {
      this.colaborador.uid = this.colaboradorSelecionado.uid;
      this.colaborador.nome = this.colaboradorSelecionado.nome;
      this.colaborador.sobrenome = this.colaboradorSelecionado.sobrenome;
      this.colaborador.isAdmin = this.colaboradorSelecionado.isAdmin;
      this.colaborador.email = this.colaboradorSelecionado.email;
      this.colaborador.horasSemana = this.colaboradorSelecionado.horasSemana;
    }
  },
  methods: {
    cadatrarColaborador() {
      this.$refs[this.colaborador].validate(valid => {
        if (valid) {
          this.carregando = true;
          this.$auth.createUserWithEmailAndPassword(this.colaborador.email, this.colaborador.senha).then(user => {
            this.$db.ref(`colaboradores/${user.user.uid}`).set({
              uid: user.user.uid,
              email: this.colaborador.email,
              isAdmin: this.colaborador.isAdmin,
              nome: this.colaborador.nome,
              sobrenome: this.colaborador.sobrenome,
              horasSemana: this.colaborador.horasSemana,
              ativado: true,
              horas: 0
            });
            this.$message.success('Colaborador cadastrado com sucesso.');
            this.fecharDialog();
            this.carregando = false;
          }).catch(error => {
            this.$message.error(`${error.code} - ${error.message}`);
            this.carregando = false;
          });
        } else this.$message.error('Existem um ou mais campos com erro no formulário. Por favor, corrija e tente novamente.');
      });
    },
    editarColaborador() {
      this.carregando = true;
      this.$db.ref(`colaboradores/${this.colaborador.uid}/`).update({
        nome: this.colaborador.nome,
        sobrenome: this.colaborador.sobrenome,
        horasSemana: this.colaborador.horasSemana
      }, error => {
        if (error) {
          this.$message.error(`${error.code} - ${error.message}`);
          this.carregando = false;
        } else {
          this.$message.success('Colaborador editado com sucesso.');
          this.fecharDialog();
        }
      });
    },
    fecharDialog() {
      this.$refs[this.colaborador].resetFields();
      this.abrirDialog.aberto = false;
    }
  }
};
</script>
